import React from "react";
import { Card, Input, Row, Col, Divider } from "antd";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";

const InvoiceTotalProductionCost = ({ invoiceData }) => {
  // Extract charges directly from invoiceData
  const printingCharge = Number(invoiceData?.printingCharge) || 0;
  const mountingCharge = Number(invoiceData?.mountingCharge) || 0;
  const totalProductionCost = printingCharge + mountingCharge;

  return (
    <Card style={{ border: "1px solid lightgrey", marginLeft: "4rem" }}>
      <Row>
        <Col span={12}>Printing Charge</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input value={formatIndianNumber(printingCharge)} readOnly />
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col span={12}>Mounting Charge</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input value={formatIndianNumber(mountingCharge)} readOnly />
        </Col>
      </Row>
      <Divider />
      <Row style={{ fontWeight: "bold", marginTop: "10px" }}>
        <Col span={12}>Total Production Cost</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatIndianNumber(totalProductionCost)}
        </Col>
      </Row>
    </Card>
  );
};

export default InvoiceTotalProductionCost;
